<template>
  <div v-if="cellProps" class="flex-row gap-xxs align-items-center">
    <a-tooltip
        :title="cellProps.fullname"
    >
      <a-avatar :src="avatarUri" size="small">
      </a-avatar>
      <span class="m-0">
        {{ name }}
      </span>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  name: 'UserAvatarCell',
  props: {
    cellProps: {
      fullname: String,
      first_name: String,
      last_name: String,
      id: String,
    },
  },
  computed: {
    avatarUri () {
      return '/user/' + this.cellProps?.id + '/avatar'
    },
    name () {
      return this.cellProps.first_name || this.cellProps.last_name || this.cellProps.fullname || 'Geen naam'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
